var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseConfirmationModal',{attrs:{"confirmText":"Report user","cancelText":"Cancel"},on:{"actionConfirmed":function($event){return _vm.$router.push({
      name: 'ReportUser',
      params: {
        userToReport: _vm.userToReport
      }
    })}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',{staticClass:"text-base font-semibold tracking-wide break-all p-4"},[_vm._v(" "+_vm._s(_vm.userToReport.displayName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }